import { EventEmitter, Input, Output, Directive } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { FormMode } from '../constants';

@Directive()
export abstract class FormCoreComponent<T> {
  FormMode = FormMode;

  @Output() submitted = new EventEmitter<T>();
  @Input() mode: FormMode = FormMode.CREATE;

  @Input()
  set disabled(val: boolean) {
    this._disabled = val;
    if (this._disabled) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }
  get disabled() {
    return this._disabled;
  }

  @Input()
  set loading(val: boolean) {
    this._loading = val;
    if (this._loading && !this.form.disabled) {
      this.form.disable();
    } else if (!this._loading && !this._disabled) {
      this.form.enable();
    }
  }
  get loading() {
    return this._loading;
  }
  @Input() error: string;

  form: UntypedFormGroup;

  protected _disabled = false;
  protected _loading = false;

  onSubmit() {
    if (this.form.valid && !this.loading) {
      this.submitted.emit(this.form.value);
    } else {
      for (const control in this.form.controls) {
        this.form.controls[control].markAsTouched();
      }
    }
  }
}
